import React from 'react';
import styled from 'styled-components';
import { Flex } from '../atoms';

const BaseStyledDiv = styled.div`
  margin-left: ${(props: { isWide: boolean }) => (props.isWide ? 24 : 12)}px;
  margin-right: ${(props: { isWide: boolean }) => (props.isWide ? 24 : 12)}px;
  margin-top: ${(props: { isWide: boolean }) => (props.isWide ? 10 : -4)}px;
  margin-bottom: ${(props: { isWide: boolean }) => (props.isWide ? 10 : 5)}px;
  color: #717171;
`;

const MainStyledDiv = styled.div`
  font-size: 12px !important;
  line-height: 18px;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;`
      : ``}
`;

interface Props {
  inquiryCategoryName?: string;
  targetDetail: { columnName: string; value: string }[];
  isWide: boolean;
}

const DescriptionColumn = styled.div.attrs<{ className: string }>({})`
  flex-basis: auto;
  white-space: nowrap;
`;

const DescriptionValue = styled.div.attrs<{ className: string }>({})`
  flex-basis: auto;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
`;

export const ChatHeaderDescription = (props: Props) => {
  const { inquiryCategoryName, isWide, targetDetail } = props;

  return (
    <BaseStyledDiv isWide={isWide} className={'chatHeaderDescription'}>
      <MainStyledDiv isWide={isWide}>
        <div className={'headerDescriptionTargetDetail'}>
          {targetDetail?.map((description, index) => {
            return (
              <Flex key={`flex-${index}`}>
                <DescriptionColumn key={`col-${index}`}>
                  {`${description.columnName}：`}
                </DescriptionColumn>
                <DescriptionValue key={`val-${index}`}>
                  {description.value}
                </DescriptionValue>
              </Flex>
            );
          })}
        </div>
        <div className={'headerDescriptionInquiryCategory'}>
          {inquiryCategoryName && (
            <Flex>
              <DescriptionColumn>{'お問い合わせ内容：'}</DescriptionColumn>
              <DescriptionValue>{inquiryCategoryName}</DescriptionValue>
            </Flex>
          )}
        </div>
      </MainStyledDiv>
    </BaseStyledDiv>
  );
};
